import React from 'react';
import { RefManager } from '_helpers';

export class PatientCareCenterNoteNavAnchor extends React.Component {

    constructor(props) {
        super(props)
        this.myRef = React.createRef()
    }

    componentDidMount() {
        RefManager.storeRef(this.props.id, this.myRef);
    }


    renderChildren() {
        if (this.props.visible) {
            return (this.props.children);
        }
        return (<span />);
    }

    render() {
        return (
            <span ref={this.myRef}>
                {this.props.children}
            </span>
        );
    }

}
